import {AbstractControl, FormGroup, ValidationErrors} from '@angular/forms';
export class PhoneNumberValidators {

  static phoneNumberRegex = new RegExp('^(\\+)((((47)|(45))\\d{8})|((46)(\\d{8,10}))|((358)(\\d{12}))|((354)(\\d{7}))|((298)(\\d{6})))$');

  static validatePhoneNumberLength( {value: phoneNumber}: AbstractControl ): ValidationErrors {
    return (PhoneNumberValidators.phoneNumberRegex.test(phoneNumber) ? null : ({ invalidPhoneNumberLength: true }));
  }

  static validatePhoneNumberCountry( formGroup: FormGroup ): ValidationErrors {
     const phoneNumberPrefix = formGroup.get('phonePrefix').value;
     const phoneNumber = phoneNumberPrefix+formGroup.get('phone').value;
     if(!PhoneNumberValidators.phoneNumberRegex.test(phoneNumber)) {
       formGroup.get('phone').setErrors({ invalidPhoneNumberLength: true });
     }
     else {
       formGroup.get('phone').setErrors(null);
     }
    return PhoneNumberValidators.phoneNumberRegex.test(phoneNumber) ? null : ({ invalidPhoneNumberLength: true });
  }
}
